import { useEffect } from "react";
import Breadcrumb from "../breacrumb/breadcrumb";
import icon1 from "../../../asset/image/new/hla-a31-01-01.svg";
import icon2 from "../../../asset/image/new/hla-a31-01-02.svg";
import icon3 from "../../../asset/image/new/hla-a31-01-03.svg";
import icon4 from "../../../asset/image/new/hla-a31-01-04.svg";
import TestingSteps from "../../../asset/image/new/hla-b-58-group.png";

function HLA5701() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ข้อมูลที่เกี่ยวข้อง", url: "/information" },
    { name: "เภสัชพันธุศาสตร์", url: "/information/pharmacogeneticTest" },
    { name: "HLA-A*31:01", url: "/information/pharmacogeneticTest/HLAA3101" },
  ];

  const Hla_57 = [
    {
      url: `${icon1}`,
      name: "HLA-A*31:01",
      title:
        "การตรวจ HLA-A*31:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Carbamazepine",
    },
    {
      url: `${icon2}`,
      name: "ความเสี่ยงต่อยา",
      title: "Carbamazepine (กลุ่มยาแก้ปวดเส้นประสาทและยากันชัก) ซึ่งเป็นยาที่ถูกนำมาใช้ในการรักษาอาการปวดเส้นประสาทใบหน้า (Trigeminal neuralgia) และรักษาอาการชัก โดยภายหลังพบว่ายีน HLA-A*31:01 เป็นตัวบ่งชี้ความเสี่ยงที่สัมพันธ์กับการเกิดผื่นแพ้ยาในรูปแบบที่มีอาการทางระบบร่างกายร่วมด้วย",
    },
    {
      url: `${icon3}`,
      name: "อาการผื่นแพ้ยา",
      title:
        "เกิดภาวะแพ้ยาที่มีผื่นแดงกระจายตามตัว ร่วมกับมีไข้สูง ต่อมน้ำเหลืองโต และมีความผิดปกติของระดับเม็ดเลือดขาว (DRESS syndrome)",
    },
    {
      url: `${icon4}`,
      name: "อาการแพ้ยารุนแรง",
      title: "ผิวหนังอักเสบแดง หน้าบวม ตาบวม และอาจส่งผลกระทบต่อการทำงานของอวัยวะภายใน เช่น ตับอักเสบ ซึ่งมักจะเริ่มแสดงอาการในช่วง 2-8 สัปดาห์หลังได้รับยา",
    },
  ];
  return (
    <div className="global-page">
      <Breadcrumb pathItems={pathItems} />
      <div className="2lg:grid-cols-1 grid grid-flow-dense grid-cols-1 w-full gap-5 py-8 mt-6">
        {Hla_57.map((hla, index) => (
          <div
            key={index}
            className="sm:flex-col sm:items-center flex flex-row gap-4"
          >
            <div className="xl:max-h-36 overflow-hidden min-w-36 w-[15%] aspect-square p-5 justify-items-center align-middle bg-white rounded-lg border border-gray-400">
              <img
                className="object-scale-down h-full"
                src={hla.url}
                alt={`รูปประกอบ ${hla.name}`}
              />
            </div>
            <div className="flex flex-col gap-1 w-[80%] py-2">
              <span className="text-xl font-bold">{hla.name}</span>
              <span>{hla.title}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="text-xl font-bold py-4">
        ขั้นตอนการตรวจยีน HLA-A*31:01
      </div>
      <div className="sm:px-2 sm:py-0 w-full aspect-[5/2] px-10 py-5 rounded-xl border border-gray-400">
        <img
          className="object-contain w-full"
          src={TestingSteps}
          alt={`รูปขั้นตอนการตรวจยีน HLA-A*31:01`}
        />
      </div>
    </div>
  );
}
export default HLA5701;
